module.exports = __webpack_public_path__ + "static/media/a-commerce.52dcfc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/a-commerce.png
// module id = 317
// module chunks = 0